import { useEffect, useState } from 'react';

export const useTime = () => {
  const [time, setTime] = useState(() => {
    const newDate = new Date();
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const hours = newDate.getHours();
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();

    return `${date < 10 ? `0${date}` : `${date}`}.${month < 10 ? `0${month}` : `${month}`}.${year} ${hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  });

  useEffect(() => {
    const separatorDate = ".";
    const separatorTime = ":";

    const intervalId = setInterval(() => {
      const newDate = new Date();
      const date = newDate.getDate();
      const month = newDate.getMonth() + 1;
      const year = newDate.getFullYear();
      const hours = newDate.getHours();
      const minutes = newDate.getMinutes();
      const seconds = newDate.getSeconds();

      setTime(
          `${date < 10 ? `0${date}` : `${date}`}${separatorDate}${month < 10 ? `0${month}` : `${month}`}${separatorDate}${year} ${hours}${separatorTime}${minutes < 10 ? `0${minutes}` : minutes}${separatorTime}${seconds < 10 ? `0${seconds}` : seconds}`
      );
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return time;
};

